// Decide qual subitem de um módulo está ativo dada a rota atual. `isActiveRoute`
// (visible-modules) casa só pela CHAVE de módulo (1º segmento), então todos os
// subitens do mesmo módulo dariam ativo — aqui precisamos do subitem específico.
// Critério: igualdade exata de routeName ou o prefixo de routeName mais longo
// (rota atual mais profunda). O sufixo '.' evita falso prefixo
// (ex.: 'financeiro' não casa com o subitem 'finance').

const NO_MATCH = ''
const NO_BEST_LENGTH = -1

/**
 * @param {Array<{ key: string, routeName?: string }>} subitems
 * @param {string} currentRouteName
 * @returns {string} key do subitem ativo, ou '' quando nenhum casa
 */
export function activeSubitemKey(subitems, currentRouteName) {
  if (!subitems || !subitems.length || !currentRouteName) return NO_MATCH
  let bestKey = NO_MATCH
  let bestLength = NO_BEST_LENGTH
  subitems.forEach((subitem) => {
    const routeName = subitem && subitem.routeName
    if (!routeName) return
    const isExact = currentRouteName === routeName
    const isPrefix = currentRouteName.indexOf(`${routeName}.`) === 0
    if ((isExact || isPrefix) && routeName.length > bestLength) {
      bestKey = subitem.key
      bestLength = routeName.length
    }
  })
  return bestKey
}
